import React, { useMemo } from 'react'
import PriceRowMarginText from '../PriceRowMarginText'
import { connect } from 'react-redux'
import useSurchargeMargin from 'hooks/Offers/useSurchargeMarginFetcher'
import { checkCanViewLuxPlusBenefits } from 'luxPlus/selectors/featureToggle'
import { sum } from 'lib/array/arrayUtils'

interface MappedProps {
  addonsByPackage: App.AddonState['addonsByPackage']
  canViewLuxPlusBenefits: boolean
  showMarginInSpoofMode: boolean
}

interface Props {
  checkIn: string | undefined
  pkg: App.Package
  type: 'exact' | 'estimate'
}

function FlashHotelMarginText(props: Props & MappedProps) {
  const {
    addonsByPackage,
    canViewLuxPlusBenefits,
    checkIn,
    pkg,
    showMarginInSpoofMode,
    type,
  } = props

  const packageAddons = addonsByPackage[pkg.id]

  const { surchargeMargin } = useSurchargeMargin({ checkIn, duration: pkg.duration, roomRateId: (pkg.roomRate?.id) })

  const surchargeMarginAud = surchargeMargin?.marginAud ?? 0
  const packageAddonsCostPriceSum = useMemo(() =>
    sum(packageAddons ?? [], addon => addon.trackingPrice),
  [packageAddons],
  )
  // the price difference between lux plus and non lux plus comes directly out of margin
  const marginToRemoveIfOnLuxPlus = canViewLuxPlusBenefits ? pkg.price - pkg.memberPrice : 0

  const marginValue = Number.isFinite(pkg.marginAud) ?
      (pkg.marginAud ?? 0) - (packageAddonsCostPriceSum ?? 0) - marginToRemoveIfOnLuxPlus :
    0

  return <>
    {showMarginInSpoofMode && <PriceRowMarginText
      size="M"
      type={type}
      marginValue={marginValue + surchargeMarginAud}
    />}
  </>
}

const mapStateToProps = (state: App.State) => ({
  addonsByPackage: state.addon.addonsByPackage,
  showMarginInSpoofMode: state.system.showMarginInSpoofMode,
  canViewLuxPlusBenefits: checkCanViewLuxPlusBenefits(state),
})

export default connect(mapStateToProps)(FlashHotelMarginText)
